import React, { useEffect, useState } from 'react';
import { Button } from '@mui/material';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import { AbsenceRequestDrawer } from 'src/features/absences';
import { Tooltip, UserXIcon } from 'src/shared/components';
import { FeaturesEnums } from 'src/shared/enums';
import { ComponentWithFeatures } from 'src/shared/hocs';
import { useFeatures, useThunkDispatch } from 'src/shared/hooks';
import { useTranslate } from 'src/shared/providers';
import { fetchApprovers, cancelAbsence, fetchAbsenceTypes } from 'src/store/absence/absences.actions';
import { RootState } from 'src/store/types';

export const MonthlyAbsenceRequest = () => {
  const { t } = useTranslate();
  const dispatch = useThunkDispatch();
  const [openRequest, setOpenRequest] = useState<boolean>(false);
  const { approvers, submitting, types } = useSelector((state: RootState) => state.absences);
  const hasAbsenceRequestFeature = useFeatures(FeaturesEnums.AbsenceRequest);

  useEffect(() => {
    if (!hasAbsenceRequestFeature) {
      return;
    }

    if (!types.length) {
      dispatch(fetchAbsenceTypes());
    }

    if (!approvers.length) {
      dispatch(fetchApprovers());
    }
  }, [hasAbsenceRequestFeature]);

  const handleAbsenceStatusUpdate = async (id: number) => {
    try {
      await dispatch(cancelAbsence({ notificationIds: [id], params: {} }));
    } catch {
      toast.info(t('global.oopsAnErrorOccurredWhileProcessingYourRequest'), { type: toast.TYPE.ERROR });
    }
  };

  return (
    <ComponentWithFeatures features={FeaturesEnums.AbsenceRequest}>
      <Tooltip title={!approvers.length ? t('absences.sorryYouNeedApproversToRequestAnAbsence') : ''}>
        <span>
          <Button
            id="request-an-absence"
            className="mb-2 mb-sm-0"
            variant="contained"
            onClick={() => setOpenRequest(true)}
            startIcon={<UserXIcon />}
            disabled={!approvers.length}
          >
            {t('absences.requestAnAbsence')}
          </Button>
        </span>
      </Tooltip>
      {!!approvers.length && (
        <AbsenceRequestDrawer
          open={openRequest}
          cancelling={submitting}
          onClose={() => setOpenRequest(false)}
          onCancelling={handleAbsenceStatusUpdate}
        />
      )}
    </ComponentWithFeatures>
  );
};
